<script>
    import Business from '@/services/Business';
    import Content from "@/services/Content";
    import Swal from "sweetalert2";
    import modalEditUserReservations from "./modalEditUserReservations";
    import modalViewEventsFields from "./modalViewEventsFields";

    export default {
        components:{
          modalEditUserReservations,
          modalViewEventsFields,
        },
        props: {
          data: {
            type: Object,
            required: true,
            default: () => ({}),
          },
        },
        data() {
          return {
              showModal: false,
              filter:"",
              sortDesc: true,
              sortBy: "name",
              tableData: [],
              totalRows: 0,
              currentPage: 1,
              perPage: 10,
              pageOptions: [10, 25, 50, 100],
              filterOn: [],
              title: null,
              start_at: null,
              error:null,
              location: null,
              registrationLimit: null,
              image:null,
              selectedData:null,
              isBusy: false,
              userLimit: null,
              companyLimit: null,
              remainingSeats: null,
              event_id: null,
              fields: [],
              allFields: [], // Store all fields for Excel export

          };
        },
      computed: {
        activeEventFields() {
          if (!this.data?.event_info?.event_fields) {
            return [];
          }
          // Get only active fields and sort by app_order
          return this.data.event_info.event_fields
            .filter(field => field.active === 1)
            .sort((a, b) => (a.app_order || 0) - (b.app_order || 0));
        },
      },

      methods: {

        openEditUserReservationsModal(data){
            this.selectedData = data;
            this.$bvModal.show('edit_user_reservations');
        },
        hasEventFields(member) {
          if (!this.activeEventFields || this.activeEventFields.length === 0) {
            return false;
          }
          return this.activeEventFields.some(field => member[field.label]);
        },
        openViewEventsFieldsModal(member) {
          let result = [];

          // Get event field definitions
          const defs = Array.isArray(this.data?.event_info?.event_fields) 
              ? this.data.event_info.event_fields 
              : [];

          // Map dynamic fields from member data
          this.activeEventFields.forEach(fieldDef => {
            const value = member[fieldDef.label] || '';
            if (value) {
              result.push({
                label: fieldDef.label,
                value: value
              });
            }
          });

          this.selectedData = result;
          this.$bvModal.show("view_events_fields");
        },

        async loadEventMembers() {
          try {
            this.toggleBusy();
            await this.eventMembersExport(this.event_id);
            this.setupTableFields();
            this.totalRows = this.tableData.length;
            this.toggleBusy();
          } catch (error) {
            this.toggleBusy();
            this.error = error.response?.data?.error ? error.response.data.error : "An error occurred while loading event members.";
            Swal.fire("Error", this.error, "error");
            this.tableData = [];
            this.totalRows = 0;
          }
        },
        setupTableFields() {
          // Define fields explicitly - you can easily add/remove fields here
          const baseFields = [
            {
              key: "customer_id",
              label: "Customer ID",
              sortable: true,
              showInTable: false
            },
            {
              key: "name",
              label: "Name",
              sortable: true,
              showInTable: false, // Hidden, but used for Reserve By
            },
            {
              key: "surname",
              label: "Surname",
              sortable: true,
              showInTable: false, // Hidden, but used for Reserve By
            },
            {
              key: "reserve_by",
              label: "Reserve By",
              sortable: true,
            },
            {
              key: "email",
              label: "Email",
              sortable: true,
            },
            {
              key: "phone_number",
              label: "Phone Number",
              sortable: true,
            },
            {
              key: "profile_url",
              label: "Profile",
              sortable: true,
              showInTable: false, // Hidden from table
            },
            {
              key: "company_name",
              label: "Company",
              sortable: true,
            },
            {
              key: "reservation",
              label: "Count",
              sortable: true,
            },
            {
              key: "reserved_for_name",
              label: "Attendee",
              sortable: true,
            },
            {
              key: "reserved_for_email",
              label: "Attendee Email",
              sortable: true,
            },
            // Add dynamic fields here manually as needed:
            {
              key: "Dieetwensen",
              label: "Dieetwensen",
              sortable: false,
              showInTable: false
            },
            {
              key: "Tafelvoorkeur",
              label: "Tafelvoorkeur",
              sortable: false,
              showInTable: false
            },
            {
              key: "Overige opmerkingen",
              label: "Overige opmerkingen",
              sortable: false,
              showInTable: false
            },
            "actions"
          ];

          // Store all fields (for Excel export)
          this.allFields = baseFields;
          
          // Filter fields for table display (hide fields with showInTable === false)
          this.fields = baseFields.filter(field => {
            if (typeof field === 'string') return true; // Keep 'actions'
            return field.showInTable !== false; // Default to true if not specified
          });
        },
        async deleteBusinessEventRegistration(event_id, customer_id) {
          Swal.fire({
            title:"Delete User Event Registration?",
            text:"This User Event Registration will be deleted!",
            icon:"warning",
            showCancelButton:true,
            confirmButtonColor:"#34c38f",
            cancelButtonColor:"#f46a6a",
            confirmButtonText:"Delete"
          }).then(async (result) => {
            if(result.isConfirmed === true){
              try {
                const response = await Business.deleteBusinessEventReservation(event_id, customer_id);
                if(response.data.success){
                  Swal.fire("Success!", "Business User is successfully deleted!", "success");
                  await this.loadEventMembers();
                } else {
                  const error = response.error ? response.error : 'Failed';
                  Swal.fire("Fail!", error, "warning");
                }
              } catch (error) {
                this.error = error.response && error.response.data && error.response.data.error
                  ? error.response.data.error
                  : "An error occurred while removing the business event registration.";
                Swal.fire("Error", this.error, "error");
              }
            }
          });
        },
        async eventMembersExport(event_id) {
          try {
            const response = await Content.getBusinessEventmembers(event_id);
            if (response && response.data) {
              this.tableData = Array.isArray(response.data) ? response.data : [];
            } else {
              this.tableData = [];
            }
          } catch (error) {
            this.tableData = [];
            console.error("Error loading event members:", error);
            throw error;
          }
        },
        onFiltered(filteredItems) {
          this.totalRows = filteredItems.length;
          this.currentPage = 1;
        },
        async exportToExcel() {
          try {
            if (!this.tableData || this.tableData.length === 0) {
              Swal.fire("Warning", "No data available to export.", "warning");
              return;
            }

            const ExcelJS = require('exceljs');
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Event Members');

            // Build column headers based on ALL fields (not just visible ones)
            // const columnHeaders = (this.allFields || this.fields)
            //   .filter(field => field !== 'actions') // Exclude actions column
            //   .map(field => {
            //     if (typeof field === 'string') {
            //       return { key: field, header: field.charAt(0).toUpperCase() + field.slice(1), width: 20 };
            //     }
            //     return { 
            //       key: field.key, 
            //       header: field.label || field.key, 
            //       width: 20 
            //     };
            //   });

            // Add header row
            // worksheet.addRow(columnHeaders.map(column => column.header));
            // worksheet.getRow(1).font = { bold: true };
            const columnHeaders = [
                        { key: 'name', header: 'Name', width: 15 },
                        { key: 'surname', header: 'Surname', width: 15 },
                        { key: 'phone_number', header: 'Phone Number', width: 15 },
                        { key: 'profile_url', header: 'Profile Url', width: 15 },
                        { key: 'company_name', header: 'Company Name', width: 15 },
                        { key: 'reservation', header: 'Count', width: 15 },
                        { key: 'reserved_for_name', header: 'Attendee', width: 15 },
                        { key: 'reserved_for_email', header: 'Attendee Email', width: 15 },
                        { key: 'Dieetwensen', header: 'Dieetwensen', width: 15 },
                        { key: 'Tafelvoorkeur', header: 'Tafelvoorkeur', width: 15 },
                        { key: 'Overige opmerkingen', header: 'Overige opmerkingen', width: 15 },
                    ];

                    // Add header row
                    worksheet.addRow(columnHeaders.map(column => column.header));
                    worksheet.getRow(1).font = { bold: true };
            // Set column widths
            columnHeaders.forEach((column, index) => {
              const columnLetter = String.fromCharCode(65 + (index % 26)) + (index >= 26 ? String.fromCharCode(65 + Math.floor(index / 26) - 1) : '');
              worksheet.getColumn(index + 1).width = column.width || 20;
            });

            // Add data rows
            this.tableData.forEach(item => {
              const rowData = columnHeaders.map(column => {
                let value = '';
                // Handle combined fields
                if (column.key === 'reserve_by') {
                  value = ((item.name || '') + ' ' + (item.surname || '')).trim();
                } else {
                  value = item[column.key];
                }
                return value !== null && value !== undefined ? String(value) : '';
              });
              worksheet.addRow(rowData);
            });

            // Generate file name
            const fileName = (this.data?.title || 'Event_Members') + '.xlsx';

            // Create blob and download
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { 
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
            });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);

          } catch (error) {
            console.error("Error exporting to Excel:", error);
            Swal.fire("Error", "Failed to export to Excel. Please try again.", "error");
          }
        },

      populateFields() {
          if (this.data) {
              this.remainingSeats = this.data.event_info.remainingSeats || "";
              this.title = this.data.title || "";
              this.start_at = this.data.start_at || "";
              this.image = this.data.image || "";
              this.location = this.data.location || "";
              this.registrationLimit = this.data.registrationLimit || "";
              this.userLimit = this.data.userLimit || "";
              this.companyLimit = this.data.companyLimit || "";
              this.event_id = this.data.event_info.event_id || "";
              
              // Load event members data
              if (this.event_id) {
                this.loadEventMembers();
              }
          }
      },

      closeModal() {
        this.showModal = false;
      },

        refreshData() {
          this.$emit('refreshScreen') //event from parent
        },
        toggleBusy() {
          this.isBusy = !this.isBusy;
        },
  },
  };

</script>

<template>
    <b-modal id="view_event_info" v-model="showModal" title="Subscribers List"  @shown="populateFields" title-class="font-18" size="xl">
    <div class="row">
        <div class="col text-center">
            <h5 class="text-uppercase font-weight-bold">Event Info</h5>
        </div>
    </div>
      <!-- <div class="flex-fill text-center mb-4 mt-4">
        <img :src="image || ''" alt="Event Image" class="img-fluid" style="max-width: 200px;" />
      </div> -->


      <div class="row mb-3">
      <div class="col">
        <div class="d-flex justify-content-between align-items-center">
          <div class="flex-fill text-center">
            <h6 class="text-uppercase">Event Name</h6>
            <p>{{ this.title || '/' }}</p>
          </div>
          <div class="flex-fill text-center">
            <h6>Date & Time</h6>
            <p>{{ this.start_at || '/' }}</p>
          </div>
          <div class="flex-fill text-center">
            <h6>Location</h6>
            <p>{{ this.location || '/' }}</p>
          </div>
          <div class="flex-fill text-center">
            <h6>Event Limit</h6>
            <p>{{ this.registrationLimit || '/' }}</p>
          </div>
          <div class="flex-fill text-center">
            <h6>User Limit</h6>
            <p>{{ this.userLimit || '/' }}</p>
          </div>
          <div class="flex-fill text-center">
            <h6>Company Limit</h6>
            <p>{{ this.companyLimit || '/' }}</p>
          </div>
          <div class="flex-fill text-center">
            <h6>Remaining Seats</h6>
            <p>{{ this.remainingSeats || '/' }}</p>
          </div>
        </div>
      </div>
    </div>

      <div class="row mt-4">
        <div class="col-sm-12 col-md-4 mb-3">
          <div id="tickets-table_length" class="dataTables_length">
            <label class="d-inline-flex align-items-center">
              Show&nbsp;
              <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;entries
            </label>
          </div>
        </div>
        <div class="col-sm-12 col-md-4 mb-3">
          <b-button
            class="btn btn-success waves-effect waves-light"
            @click="exportToExcel"
            :disabled="!tableData || tableData.length === 0"
          >
            <i class="uil uil-file-excel-alt me-2"></i>
            Export to Excel
          </b-button>
        </div>
        <!-- Search -->
        <div class="col-sm-12 col-md-4">
          <div id="tickets-table_filter" class="dataTables_filter text-md-end">
            <label class="d-inline-flex align-items-center">
              Search:
              <b-form-input v-model="filter" type="search" placeholder="Search..."
                            class="form-control form-control-sm ms-2"></b-form-input>
            </label>
          </div>
        </div>
        <!-- End search -->
      </div>

      <!-- Table -->
      <div class="table-responsive mb-0">
        <b-table 
          :busy="isBusy" 
          :items="tableData" 
          :fields="fields" 
          responsive="sm"
          :per-page="perPage" 
          :current-page="currentPage" 
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc" 
          :filter="filter" 
          :filter-included-fields="filterOn"
          show-empty 
          empty-text="No Data Found" 
          @filtered="onFiltered"
        >
          <template v-slot:cell(reserve_by)="data">
            {{ ((data.item.name || '') + ' ' + (data.item.surname || '')).trim() || '—' }}
          </template>
          <template v-slot:cell(actions)="data">
            <ul class="list-inline mb-0 d-flex" style="display: flex; flex-wrap: nowrap; align-items: center;">
              <li class="list-inline-item" style="display: inline-block; white-space: nowrap;">
                <a
                  v-if="hasEventFields(data.item)"
                  href="javascript:void(0);"
                  class="px-2 text-primary"
                  v-b-tooltip.hover
                  title="View Info"
                  @click="openViewEventsFieldsModal(data.item)"
                >
                  <i class="uil uil-clipboard-notes font-size-18"></i>
                </a>
              </li>
              <li class="list-inline-item" style="display: inline-block; white-space: nowrap;">
                <a
                  href="javascript:void(0);"
                  class="px-2 text-primary"
                  v-b-tooltip.hover
                  title="Edit Reservation"
                  @click="openEditUserReservationsModal(data.item)"
                >
                  <i class="uil uil-pen font-size-18"></i>
                </a>
              </li>
              <li class="list-inline-item" style="display: inline-block; white-space: nowrap;">
                <a 
                  href="javascript:void(0);" 
                  class="px-2 text-danger" 
                  title="Delete Reservation" 
                  @click="deleteBusinessEventRegistration(event_id, data.item.customer_id)"
                >
                  <i class="uil uil-trash-alt font-size-18"></i>
                </a>
              </li>
            </ul>
          </template>

          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
        </b-table>
      </div>

      <div class="row">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    <template v-slot:modal-footer>
      <b-button variant="light" @click="closeModal">Close</b-button>
    </template>
        <modalEditUserReservations
                :selectedData="selectedData"
                 @onRefresh="loadEventMembers()"
        ></modalEditUserReservations>
        <modalViewEventsFields
            :selectedData="selectedData"
            @onRefresh="loadEventMembers()"
        />

    </b-modal>
  </template>
